import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { pb } from '../../../helpers/pocketbase_helper';
import { logoutUserSuccess } from '../login/actions';
import { 
  REDIRECT_TO_LOGIN,
  REDIRECT_COMPLETED,
  CLEAR_AUTH_DATA
} from './actions';

/**
 * Handles automatic logout and redirect to login when token is invalid
 * @param {Object} action - Redux action with redirect information
 */
function* handleAutomaticLogout(action) {
  try {
    const { pathname, navigate, reason } = action.payload;

    // Clear PocketBase authentication
    yield call(pb.authStore.clear);

    // Clear localStorage authentication data
    localStorage.removeItem('authUser');

    // Dispatch logout success
    yield put(logoutUserSuccess());

    // Clear auth data action
    yield put({
      type: CLEAR_AUTH_DATA,
      payload: { clearedAt: new Date().toISOString() }
    });

    // Navigate to login with current path as redirect
    if (navigate) {
      navigate('/login', { 
        state: { from: pathname },
        replace: true 
      });
    }

    // Dispatch redirect completed
    yield put({
      type: REDIRECT_COMPLETED,
      payload: { 
        redirectedTo: '/login', 
        from: pathname,
        reason: reason || 'token_expired'
      }
    });

  } catch (error) {
    console.error('Automatic logout error:', error);
    
    // Even if there's an error, try to clear data and redirect
    try {
      localStorage.removeItem('authUser');
      if (action.payload.navigate) {
        action.payload.navigate('/login', { replace: true });
      }
    } catch (redirectError) {
      console.error('Redirect error:', redirectError);
    }

    yield put({
      type: 'API_ERROR',
      payload: 'Failed to logout automatically'
    });
  }
}

/**
 * Handles clearing all authentication data
 * @param {Object} action - Redux action
 */
function* handleClearAuthData(action) {
  try {
    // Clear all auth-related localStorage items
    const authKeys = ['authUser', 'authToken', 'userSession'];
    
    authKeys.forEach(key => {
      if (localStorage.getItem(key)) {
        localStorage.removeItem(key);
      }
    });

    // Clear any other auth-related data
    sessionStorage.removeItem('authUser');
    sessionStorage.removeItem('authToken');

    console.log('Authentication data cleared successfully');

  } catch (error) {
    console.error('Error clearing auth data:', error);
  }
}

/**
 * Main redirect saga watcher
 */
export function* redirectSaga() {
  yield takeEvery(REDIRECT_TO_LOGIN, handleAutomaticLogout);
  yield takeEvery(CLEAR_AUTH_DATA, handleClearAuthData);
}

// Export individual sagas for testing
export { handleAutomaticLogout, handleClearAuthData };
